/* eslint-disable no-continue */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, {
  useCallback,
  useMemo,
  useState,
  useRef,
  useEffect,
} from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { Formik, Form, Field } from "formik";
import { withFormikDevtools } from "formik-devtools-extension";
import { isProduction } from "src/config/index";
import PropTypes from "prop-types";
// import { DATE_TIME_FORMAT } from 'src/constants/CommonConstants';
import FormikCreateSearchClear from "src/components/formik/FormikCreateSearchClear";
import FormikDateTimePicker from "src/components/formik/FormikDateTimePicker";
import Table from "src/components/table/Table";
import { set } from "lodash";
import { getEndOfDay, getStartOfDay } from "src/utils/DadeUtils";
import {
  caseEditAction,
  caseResetAction,
  caseSearchAction,
} from "../case-container/actions/CaseActions";
import { headerShowAction } from "../header-container/actions/HeaderActions";
import RoutingUtil from "src/utils/RoutingUtil";
import OpenNewTabLink from "src/components/OpenNewTabLink";
import { userSearchAPI } from "src/api/UserApi";
import {
  PRODUCT_CATEGORY_TYPES_LIST,
  CAR_LOAN_TYPE_LIST,
  USED_CAR_LOAN_TYPE_LIST,
} from "../product-container/ProductConstants";
import CompanyDropDown from "src/business-components/CompanyDropDown";
import UserDropDown from "src/business-components/UserDropDown";
import CommissionManagerDropDown from "src/business-components/CommissionManagerDropDown";
import FormikSelect from "src/components/formik/FormikSelect";
import { PAYOUT } from "../company-container/CompanyConstants";
import FormikCheckBox from "src/components/formik/FormikCheckBox";
import { caseInvoiceCreateAPI, pipelineApi } from "src/api/CaseApi";
import LinkComponent from "src/components/LinkComponent";
import { Route, Switch } from "react-router-dom";
import Invoice from "./Invoice";
import { useHistory } from "react-router";
import { commissionSearchAction } from "../commission-container/actions/CommissionActions";
import { commissionSearchAPI } from "src/api/CommissionApi";
import { EMPLOYMENT_TYPES_LIST } from "../user-container/UserConstants";
import { DATA_TYPE } from "src/constants/CommonConstants";
import { remarkSearchAPI } from "src/api/RemarkApi";
import { ExportReactCSV } from "src/components/excel/ExportReactCSV";
import FormikInput from "src/components/formik/FormikInput";
import { DATE_TIME_FORMAT } from "src/constants/CommonConstants";
import { PAYMENT_MODE_TYPES_LIST } from "../product-container/ProductConstants";
import PayRecPopup from "./PayRecPopup";
import { companySearchAPI } from "src/api/CompanyApi";
import { excelCaseSearchAction } from "../excel-container/actions/ExcelActions";
import CustomerDropDown from "src/business-components/CustomerDropDown";

const RenderFilters = (props) => {
  // DEV TOOL
  if (!isProduction()) {
    withFormikDevtools(props);
  }

  const {
    // errors,
    // touched,
    isSubmitting,
    onClear,
    // forceRefreshSearchContainer,
    resetForm,
    values,
    activityList,
    userType,
    ExportInExcel,
    handleChange,
    generateInvoice,
    handleReceipt,
    handlePayment,
    history,
    onPageChange,
    alertModalClass,
    alertDisplay,
    openAlertDialog,
    closeAlertDialog,
    viewRemarks,
    editClick,
    dueAmountModalClass,
    dueAmountDisplay,
    payoutModalClass,
    payoutDisplay,
    totalPayout,
    totalDueAmount,
    paid,
    netPaid,
    received,
    netReceived,
    grossLoan,
    netLoan,
    totalCheckedDue,
    invoiceInitialValues,
    totalCheckedPayOut,
    pendingDueList,
    pendingPayOutList,
    total,
  } = props;
  // console.log("invoiceInitialValues=>", invoiceInitialValues);

    //Deepcopy of EMPLOYMENT_TYPES_LIST
    const Employment_List = JSON.parse(JSON.stringify(EMPLOYMENT_TYPES_LIST));
    Employment_List.push({
      value: 'onroll&dsa',
      label: 'Onroll&DSA',
  });
  
  return (
    <div>
      <div style={{ justifyContent: "center", display: "flex", padding: "px" }}>
        <h2>Car Loan Payout Calculation</h2>
      </div>
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Search Filters</h5>
          <Form>
            <div className="form-row">
              <div className="form-group col-md-3">
                <label>Category</label>
                {/* <FormikSelect
                  items={PRODUCT_CATEGORY_TYPES_LIST}
                  name="productCategory"
                  className="form-control"
                /> */}
                 <Field
                  type="text"
                  className="form-control"
                  disabled
                  value="Car Loan"
                  name="productCategory"
                  initialValue="CAR_LOAN"
                />
              </div>
              {/* {values.productCategory === "CAR_LOAN" && ( */}
                <div className="form-group col-md-3">
                  <label>Loan Type</label>
                  <FormikSelect
                    items={CAR_LOAN_TYPE_LIST}
                    name="loanType"
                    className="form-control"
                    disabled ={Boolean(values.FilterCommissionId)}
                  />
                </div>
              {/* )} */}
              {/* {values.productCategory === "CAR_LOAN" && */}
                {values.loanType === "USED" && (
                  <div className="form-group col-md-3">
                    <label>Used Car Loan Type</label>
                    <FormikSelect
                      items={USED_CAR_LOAN_TYPE_LIST}
                      name="usedCarLoanType"
                      className="form-control"
                    />
                  </div>
                )}
              <div className="form-group col-md-3">
                <label>From Date</label>
                <FormikDateTimePicker
                  name="CaseFromDate"
                  className="form-control"
                  disableClock
                  format="dd-MM-y"
                  disabled={Boolean(values.FilterCommissionId)}
                />
              </div>
              <div className="form-group col-md-3">
                <label>To Date</label>
                <FormikDateTimePicker
                  name="CaseToDate"
                  className="form-control"
                  disableClock
                  format="dd-MM-y"
                  disabled={Boolean(values.FilterCommissionId)}
                />
              </div>
              <div className="form-group col-md-3">
                <label>Company</label>
                <CompanyDropDown name="companyId" 
                value={values.companyId} />
                disabled={Boolean(values.FilterCommissionId)}
              </div>
              <div className="form-group col-md-3">
                <label>Assigned Agent</label>
                <UserDropDown name="agentId" value={values.agentId} />
              </div>
              <div className="form-group col-md-3">
                <label>Reporting Manager</label>
                <UserDropDown
                  name="reportingManagerId"
                  value={values.reportingManagerId}
                />
              </div>
              <div className="form-group col-md-3">
                <label>Employment Type</label>
                <FormikSelect
                  items={EMPLOYMENT_TYPES_LIST}
                  name="employmentType"
                  className="form-control"
                />
              </div>
              <div className="form-group col-md-6">
                <label>Customer</label>
                <CustomerDropDown name="customerId" value={values.customerId} />
              </div>
              <div className="form-group col-md-3">
                <label>Commission</label>
                <CommissionManagerDropDown
                  name="FilterCommissionId"
                  value={values.FilterCommissionId}
                  placeholder="Default Comission"
                />
              </div>

              {values.FilterCommissionId ? (
                <div className="col-md-6">
                  <table className="table">
                    <thead>
                      <tr>
                        <th scope="col">Target</th>
                        <th scope="col">Reward</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Tillnow</th>
                        <th scope="col">Short Amount</th>
                        <th scope="col">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {activityList.commissionDetails.map(
                        (commission, index) => {
                          return (
                            <tr
                              key={index}
                              style={{
                                backgroundColor:
                                  commission.status == "Completed"
                                    ? "#81e381"
                                    : "#f1f16d",
                              }}
                            >
                              <td>{commission.commissionTarget}</td>
                              <td>
                                {commission.reward}
                                {commission.isRewardPercentage ? "%" : ""}
                              </td>
                              <td>{commission.status === "Completed" ? commission.amount: 0 }</td>
                              <td>{commission.tillNow}</td>
                              <td>{commission.short}</td>
                              <td>{commission.status}</td>
                            </tr>
                          );
                        }
                      )}
                    </tbody>
                  </table>
                </div>
              ) : null}
            </div>
            <div className="text-center py-4 mt-3">
              <FormikCreateSearchClear
                isSubmitting={isSubmitting}
                onClear={onClear}
                resetForm={resetForm}
                submitButtonText="Search"
                submitScope="reports.account_payoutCal.search"
              />
            </div>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                openAlertDialog("invoice");
              }}
            >
              Create Invoice
            </button>

            <button
              type="button"
              className="btn btn-primary mx-2"
              onClick={() => {
                openAlertDialog("dueAmount");
              }}
            >
              Receipt
            </button>

            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                openAlertDialog("Payout");
              }}
            >
              Payment
            </button>
          </Form>
        </div>
      </div>

      {/* invoice */}
      {/* <div className={`modal fade ${(invoiceModal) ? 'show' : ''}`} id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"> */}
      <div
        className={`modal fade ${alertModalClass}`}
        id="authAlert"
        style={{
          display: `${alertDisplay}`,
          overflowY: "scroll",
          opacity: "1",
          background: "rgba(0, 0, 0, 0.5)",
        }}
      >
        {/* <div className="modal fade show" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" style={{ display: 'block', paddingRight: '5px' }} aria-modal="true" role="dialog"> */}
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Create Invoice
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => closeAlertDialog("invoice")}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group col-md-12">
                <label>Commission</label>
                <CommissionManagerDropDown
                  name="commissionId"
                  value={values.commissionId}
                  placeholder="Default Comission"
                />
              </div>
            </div>
            <div className="modal-body">
              <div className="form-group col-md-12">
                <label>Loan A/C/Policy Number</label>
                <FormikInput
                  name="LoanPolicyNumber"
                  type="text"
                  placeholder="enter Loan A/C/Policy Number"
                  value={values.LoanPolicyNumber}
                  className="form-control"
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => closeAlertDialog("invoice")}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  generateInvoice(values.commissionId);
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Due amount */}
      <PayRecPopup
        type="rec"
        invoiceInitialValues={invoiceInitialValues}
        totalReceived={received}
        dueAmountModalClass={dueAmountModalClass}
        dueAmountDisplay={dueAmountDisplay}
        totalCheckedDue={totalCheckedDue}
        closeAlertDialog={closeAlertDialog}
        pendingAmountList={pendingDueList}
      />
      {/*  */}

      {/*  Payout */}
      <PayRecPopup
        type="pay"
        invoiceInitialValues={invoiceInitialValues}
        totalReceived={paid}
        dueAmountModalClass={dueAmountModalClass}
        dueAmountDisplay={payoutDisplay}
        totalCheckedDue={totalCheckedPayOut}
        closeAlertDialog={closeAlertDialog}
        pendingAmountList={pendingPayOutList}
      />
      {/*  */}

      <div className="border-top my-3" />

      <div className="card mt-3">
        <div className="card-body">
          <h5 className="card-title">
            Search Results
            <ExportReactCSV
              csvData={ExportInExcel}
              fileName={"Loan-Payout-Report-" + new Date().toLocaleDateString()}
            />
          </h5>

          <div className="mb-2 border p-2 float-left">
            <span className="mr-2 border badge badge-secondary status-Total mb-2">
              <div>
                <label>Gross Loan Amount</label>
                <div>
                  <input
                    className="text-center font-weight-bold text-black"
                    type="text"
                    value={total?.totalGrossAmt || 0}
                    disabled
                  />
                </div>
              </div>
            </span>
            <span className="mr-2 border badge badge-secondary status-Total mb-2">
              <div>
                <label>Net Loan Amount</label>
                <div>
                  <input
                    className="text-center font-weight-bold text-black"
                    type="text"
                    value={total?.totalNetAmt || 0}
                    disabled
                  />
                </div>
              </div>
            </span>
            <span className="mr-2 border badge badge-secondary status-Total mb-2">
              <div>
                <label>Due(Pay IN) Amount</label>
                <div>
                  <input
                    className="text-center font-weight-bold text-black"
                    type="text"
                    value={total?.totalDueAmount || 0}
                    disabled
                  />
                </div>
              </div>
            </span>
            <span className="mr-2 border badge badge-secondary status-Total mb-2">
              <div>
                <label>Received</label>
                <div>
                  <input
                    className="text-center font-weight-bold text-black"
                    type="text"
                    value={total?.totalExistingAmountForDue}
                    disabled
                  />
                </div>
              </div>
            </span>
            <span className="mr-2 border badge badge-secondary status-Total mb-2">
              <div>
                <label>Payout(Pay OUT) Amount</label>
                <div>
                  <input
                    className="text-center font-weight-bold text-black"
                    type="text"
                    value={total?.totalPayoutAmount || 0}
                    disabled
                  />
                </div>
              </div>
            </span>
            <span className="mr-2 border badge badge-secondary status-Total mb-2">
              <div>
                <label>Paid</label>
                <div>
                  <input
                    className="text-center font-weight-bold text-black"
                    type="text"
                    value={netPaid}
                    disabled
                  />
                </div>
              </div>
            </span>
          </div>
          <Table
            recordsPerPage={50}
            onPageChange={onPageChange}
            searchData={{
              data: activityList.data,
              count: activityList.count,
              currentPage: activityList.currentPageIndex,
              //payoutAmt=agentcmsn*loanamt
            }}
            columns={{
              group: [
                {
                  display: "Loan Date",
                  type: Date,
                  path: "meta.loanDate",
                  format: DATE_TIME_FORMAT.DATE,
                },
                {
                  display: "Loan Type",
                  path: "meta.loanType",
                },
                //   {
                //     display: "Car Loan Type",
                //     path: "meta.usedCarType",
                //   },
                {
                  display: "Loan A/c Number",
                  path: "meta.LoanAccountNo",
                },
                // {
                //   display: "Policy Number",
                //   path: "coverNotes.cn_number",
                // },

                {
                  display: "Name of Customer",
                  path: "customerName",
                },
                {
                  display: "Brand Name",
                  path: "meta.vehicleProductId.manufacturer.companyName",
                },
                {
                  display: "Model Name",
                  path: "meta.vehicleProductId.productName",
                },
                {
                  display: "Cubic Capacity",
                  path: "meta.vehicleProductId.meta.cubicCapacity",
                },
                {
                  display: "Fuel Type",
                  path: "meta.vehicleProductId.meta.fuelType",
                },
                {
                  display: "Loan Amount",
                  type: DATA_TYPE.Decimal,
                  path: "meta.loanAmount",
                },
                {
                  display: "Cross Sell Amount",
                  type: DATA_TYPE.Decimal,
                  path: "CrossSellAmount",
                },
                {
                  display: "Advance EMI",
                  type: DATA_TYPE.Decimal,
                  path: "meta.EMIAdvance",
                },
                {
                  display: "EMI Amount",
                  type: DATA_TYPE.Decimal,
                  path: "meta.EMIAmount",
                },
                {
                  display: "Gross Loan Amount",
                  type: DATA_TYPE.Decimal,
                  path: "meta.grossLoanAmount",
                },
                {
                  display: "Tenure",
                  path: "meta.tenure",
                },
                {
                  display: "ROI",
                  type: DATA_TYPE.Decimal,
                  path: "meta.businessIRR",
                },
                {
                  display: "Processing Fees",
                  type: DATA_TYPE.Decimal,
                  path: "meta.processingFees",
                },
                {
                  display: "Disbursed Amount",
                  type: DATA_TYPE.Decimal,
                  path: "meta.disbursedAmount",
                },

                {
                  display: "Disbursal Dealer/Showroom",
                  path: "meta.showroomDealer.companyDisplayName",
                },
                {
                  display: "Bank/Company Name",
                  path: "companyId.companyName",
                },
                {
                  display: "Assigned Agent Name",
                  path: "agentName",
                },
                {
                  display: "Reporting Manager Name",
                  path: [
                    "reportingManagerId.personalInfo.firstName",
                    "reportingManagerId.personalInfo.lastName",
                  ],
                },
                {
                  display: "Bank Monthly Payment Rate (%)",
                  type: DATA_TYPE.Decimal,
                  path: "companyCommissionPercentage",
                },
                {
                  display: "Monthly Due Amount",
                  type: DATA_TYPE.Decimal,
                  path: "DueAmount",
                },
                {
                  display: "PDD Amount",
                  type: DATA_TYPE.Decimal,
                  path: "PddAmount",
                },
                {
                  display: "Received Amount",
                  type: DATA_TYPE.Decimal,
                  path: "receiptAmount",
                },
                {
                  display: "short Amount",
                  type: DATA_TYPE.Decimal,
                  path: "shortAmount",
                },
                {
                  display: "Agent Payout Rate(%)",
                  type: DATA_TYPE.Decimal,
                  path: "agentCommissionPercentage",
                },
                {
                  display: "Payout Amount",
                  type: DATA_TYPE.Decimal,
                  path: "payoutAmount",
                },
                {
                  display: "Paid Amount",
                  type: DATA_TYPE.Decimal,
                  path: "paymentAmount",
                },
                {
                  display: "Disbursement Date",
                  type: Date,
                  format: DATE_TIME_FORMAT.DATE,
                  path: "meta.loanDate",
                },
                // {
                //     display: "Due Amount",
                //     path: "DueAmount",
                // },
                {
                  display: "GST(Inc/Exc)",
                  type: DATA_TYPE.Decimal,
                  path: "GSTEncExc",
                },
                {
                  display: "Saving",
                  type: DATA_TYPE.Decimal,
                  path: "difference",
                },
                {
                  display: "Created By",
                  path: "by.personalInfo.firstName",
                },
                // {
                //     display: "Day Count",
                //     path: "dayCount",
                // },
                {
                  display: "Date",
                  type: Date,
                  format: DATE_TIME_FORMAT.DATE,
                  path: "ts",
                },
              ],
            }}
            rowColoring={[
              // list should be priority wise
              {
                reason: "Pending",
                rowClass: "status-pending",
                shouldApply: (record) => record.isPending,
              },
              {
                reason: "Critical",
                rowClass: "status-critical",
                shouldApply: (record) => record.isCritical,
              },
            ]}
            customActions={[
              {
                heading: "Check For Select",
                // eslint-disable-next-line react/prop-types
                Render: ({ record }) => {
                  return (
                    // <PermissionHOC
                    //     scope="mis.case_mis.case_report"
                    // >
                    //     <OpenNewTabLink
                    //         url={RoutingUtil.caseActivityReport(record.caseInfo._id)}
                    //         title={record.caseInfo.caseDetails.caseCode}
                    //     />
                    // </PermissionHOC>
                    <>
                      <FormikCheckBox
                        className="ml-2 big-checkbox"
                        name={`${record._id}`}
                        value={record._id}
                        checked={true}
                        // data-payment={`${record.payOut}`}
                        // data-receipt={`${record.receipt}`}
                        data-due={`${record.DueAmount}`}
                        data-Payout={`${record.payoutAmount}`}
                        data-paid={`${record.paymentAmount}`}
                        data-received={`${record.receiptAmount}`}
                        onClick={handleChange}
                      />
                    </>
                  );
                },
              },

              // {
              //     heading: "View Invoice",
              //     Render: ({ record }) => {
              //         return (
              //             <LinkComponent
              //                 onClick={() => history.push(`/invoice/${record._id}`)}
              //             >
              //                 <i className="fas fa-eye" />
              //             </LinkComponent>
              //         );
              //     },
              // },
              // {
              //     heading: "Bank Receipts",
              //     Render: ({ record }) => {
              //         return (
              //             <LinkComponent
              //                 onClick={() => history.push(`/receipt/${record._id}`)}
              //             >
              //                 <i className="fas fa-eye" />
              //             </LinkComponent>
              //         );
              //     },
              // },
              // {
              //     heading: "Agent Payments",
              //     Render: ({ record }) => {
              //         return (
              //             <LinkComponent
              //                 onClick={() => history.push(`/payment/${record._id}`)}
              //             >
              //                 <i className="fas fa-eye" />
              //             </LinkComponent>
              //         );
              //     },
              // },
              // {
              //     heading: "View Remarks",
              //     Render: ({ record }) => {
              //         return (
              //             <LinkComponent onClick={() => viewRemarks(record._id)}>
              //                 <i className="fas fa-eye " />
              //             </LinkComponent>
              //         );
              //     },
              // },
              {
                heading: "View Case Manager",
                Render: ({ record }) => {
                  return (
                    <LinkComponent onClick={() => editClick(record)}>
                      <i className="fas fa-pen" />
                    </LinkComponent>
                  );
                },
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
};

RenderFilters.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  onClear: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  values: PropTypes.any.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  // activityList: PropTypes.Object.isRequired,
};

// setting submit button state after submitting
const filterDefaultValues = {
  verifierId: "",
  clientId: "",
  branchId: "",
  // CaseFromDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
  CaseFromDate: null,
  // CaseToDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
  CaseToDate: null,
  caseId: "",
  caseStatus: "",
  overAllcaseStatus: "",
  LoanPolicyNumber: "",
  PaymentDue: 0,
  ReceiptDue: 0,
};

const AccntPayoutCal = () => {
  const [filterInitialValues, setFilterInitialValues] = useState({
    ...filterDefaultValues,
  });

  const [currentProductCategory, setProductCategory] = useState();

  const [currentCompany, setCurrentCompany] = useState();

  const [currentActivityAssignedDateTill, setCurrentActivityAssignedDateTill] =
    useState();

  const [currentActivityAssignedDateFrom, setCurrentActivityAssignedDateFrom] =
    useState();

  const [invoiceInitialValues, setInvoiceInitialValues] = useState([]);
  const [receiptValues, setReceiptValues] = useState([]);
  const [pendingPayOutList, setPendingPayOutList] = useState([]);
  const [pendingDueList, setPendingDueList] = useState([]);

  const [where, setWhere] = useState({});

  const [currentPageIndex, setCurrentPageIndex] = useState(0);

  const [alertModalClass, setAlertModalClass] = useState(false);
  const [alertDisplay, setAlertDisplay] = useState(false);
  const [dueAmountModalClass, setDueAmountModalClass] = useState(false);
  const [dueAmountDisplay, setDueAmountDisplay] = useState(false);
  const [payoutModalClass, setPayoutsModalClass] = useState(false);
  const [payoutDisplay, setPayoutDisplay] = useState(false);
  const [remarksModalClass, setRemarksModalClass] = useState(false);
  const [remarksDisplay, setRemarksDisplay] = useState(false);
  const [remarksDetails, setRemarksDetails] = useState([]);

  const [commissionMaster, setCommissionMaster] = useState({ slab: [] });
  const [totalPayout, setTotalPayout] = useState(0);
  const [totalDueAmount, setTotalDueAmount] = useState(0);
  const [netPaid, setNetPaid] = useState(0);
  const [paid, setPaid] = useState(0);
  const [netReceived, setTotalReceived] = useState(0);
  const [received, setReceived] = useState(0);
  const [grossLoan, setGrossLoan] = useState(0);
  const [netLoan, setNetLoan] = useState(0);
  const [totalCheckedPayOut, setTotalCheckedPayOut] = useState(0);
  const [totalCheckedDue, setTotalCheckedDue] = useState(0);
  const [total, setTotal] = useState({})

  const openAlertDialog = (type) => {
    if (type === "invoice") {
      setAlertDisplay("block");
      setAlertModalClass("show");
    } else if (type === "remarks") {
      setRemarksDisplay("block");
      setRemarksModalClass("show");
    } else if (type === "dueAmount") {
      setDueAmountDisplay("block");
      setDueAmountModalClass("show");
    } else if (type === "Payout") {
      setPayoutDisplay("block");
      setPayoutsModalClass("show");
    }

    if (document.body.style.overflow !== "hidden") {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "scroll";
    }
  };
  const closeAlertDialog = (type) => {
    if (type === "invoice") {
      setAlertModalClass("none");
      setAlertDisplay("");
    } else if (type === "remarks") {
      setRemarksModalClass("none");
      setRemarksDisplay("");
    } else if (type === "dueAmount") {
      setDueAmountDisplay("none");
      setDueAmountModalClass("");
    } else if (type === "Payout") {
      setPayoutDisplay("none");
      setPayoutsModalClass("");
    }

    if (document.body.style.overflow !== "scroll") {
      document.body.style.overflow = "scroll";
    } else {
      document.body.style.overflow = "hidden";
    }
    // onSearchSubmit();
    // dispatch(
    //   caseSearchAction({
    //     where,
    //     currentPage: 0,
    //     sortBy: "ts",
    //     sortOrder: -1,
    //     fullTextSearch: false,
    //     pageLength: 50,
    //   })
    // );
  };

  let data = [];
  // REDUX
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    search: { data: searchResults, count },
  } = useSelector((state) => state.CaseReducer, shallowEqual);
  const {
    search: { data: excelSearchResults, excelCount },
  } = useSelector((state) => state.ExcelReducer, shallowEqual);

  const { userType, userId } = useSelector(
    (state) => state.AuthReducer,
    shallowEqual
  );
  const getPayout = (caseInfo, type) => {
    // PAYOUT
    let amount = 0;
    let ExistingAmount = 0;
    const duePercentage = caseInfo?.companyCommissionPercentage || 0;
    const PayoutPercentage = caseInfo?.agentCommissionPercentage || 0;
    // const increasedPayoutPercentage = Math.round((duePercentage + (duePercentage * 0.09)) * 100) / 100;
    const increasedPayoutPercentage = duePercentage + (duePercentage * 0.09);
    const payInPercentage = (caseInfo?.companyId?.companyName === 'HDFC BANK' && caseInfo?.companyId?.usedGSTCalc === "usedIsExclusiveHalf") ? increasedPayoutPercentage : duePercentage;
    const Percentage =
      type == "Payout"
        ? PayoutPercentage
        :payInPercentage;
    if (caseInfo.companyId.payOut === PAYOUT.LOANAMT)
      amount = Math.round(
        (caseInfo.meta.loanAmount -
          caseInfo.meta.EMIAmount *
            caseInfo.meta.EMIAdvance *
            Percentage) /
          100,
        2
      );
    else if (caseInfo.companyId.payOut === PAYOUT.LOANAMT_CROSSSALE)
      amount = Math.round(
        ((caseInfo.meta.loanAmount -
          caseInfo.meta.EMIAmount * caseInfo.meta.EMIAdvance +
          caseInfo.meta.crossSaleAmount) *
          Percentage) /
          100,
        2
      );
    else if (caseInfo.companyId.payOut === PAYOUT.LOANAMT_LESS_PF)
      amount = Math.round(
        ((caseInfo.meta.loanAmount -
          caseInfo.meta.EMIAmount * caseInfo.meta.EMIAdvance -
          caseInfo.meta.processingFees) *
          Percentage) /
          100,
        2
      );
    else
      amount = Math.round(
        ((caseInfo.meta.loanAmount -
          caseInfo.meta.EMIAmount * caseInfo.meta.EMIAdvance +
          caseInfo.meta.crossSaleAmount -
          caseInfo.meta.processingFees) *
          Percentage) /
          100,
        2
      );

      const paymentDetails = type === "Payout" ? caseInfo.paymentDetails : caseInfo.recieptDetails;
      ExistingAmount = paymentDetails?.reduce((sum, payment) => {
        if (payment.deleted === true) {
          return sum; // Skip this payment object if deleted is true
        } else {
          return sum + payment.amount;
        }
      }, 0);

    amount -= ExistingAmount || 0;
  return isNaN(amount) ? 0 : amount;
};

  const getGSTCalc = (DueAmt, ngstCalc, ugstCalc, loanCategory,companyName) => {
    // PAYOUT
    let amount = 0;
    if (loanCategory === "NEW") {
      if (ngstCalc === "newIsExclusive")
        // amount = Math.round(DueAmt + (DueAmt * 18) / 100);
        amount = Math.round((DueAmt * 18) / 100);
      else if (ngstCalc === "newIsInclusive")
        // amount = Math.round(DueAmt - ((DueAmt / 1.18) * 18) / 100);
        amount = Math.round(((DueAmt / 1.18) * 18) / 100);
      else if (ngstCalc === "newIsExclusiveHalf")
        // amount = Math.round(DueAmt + (DueAmt * 9) / 100);
        amount = Math.round((DueAmt * 9) / 100);
      //  (ngstCalc === "newIsExclusive18/118")
      // amount = Math.round(DueAmt + (DueAmt * 18) / 118);
      else amount = Math.round((DueAmt * 18) / 118);
    }
    if (loanCategory === "USED") {
      if (ugstCalc === "usedIsExclusive")
        // amount = Math.round(DueAmt + (DueAmt * 18) / 100);
        amount = Math.round((DueAmt * 18) / 100);
      else if (ugstCalc === "usedIsInclusive")
        // amount = Math.round(DueAmt - ((DueAmt / 1.18) * 18) / 100);
        amount = Math.round(((DueAmt / 1.18) * 18) / 100);
      else if (ugstCalc === "usedIsExclusiveHalf")
        if(companyName === 'HDFC BANK'){
          amount = Math.round((DueAmt * 18) / 118);
        }
        else{
          amount = Math.round((DueAmt * 9) / 100);
        }
      else amount = Math.round((DueAmt * 18) / 118);
    }
    return isNaN(amount) ? 0 : amount;
  };

  const getPDDAmount = (newPDDamount, usedPDDamount, loanCategory) => {
    let pddAmount = 0;
    if (loanCategory === "NEW") {
      pddAmount = newPDDamount;
    } else if (loanCategory === "USED") {
      pddAmount = usedPDDamount;
    }
    return isNaN(pddAmount) ? 0 : pddAmount;
  };

  const getTotalAmount = (Object) => {
    let totalAmt = 0;
    Object.map((obj) => {
      if (!obj?.deleted) {
        totalAmt += obj.amount || 0;
      }
    });
    return isNaN(totalAmt) ? 0 : totalAmt;
  };
  // const getTotalPDDAmount = (Object) => {
  //     let totalPDDAmt = 0;
  //     Object.map((obj) => {
  //         totalPDDAmt += obj.PDDamount || 0;
  //     });
  //     return isNaN(totalPDDAmt) ? 0 : totalPDDAmt;
  // };
  const getCommissionDetails = () => {
    try {
      if (!Array.isArray(commissionMaster.slab)) {
        throw new Error("Commission slab is not an array");
      }

      const commissionDetails = commissionMaster.slab.map((slab) => {
        const status = (total?.totalGrossAmt || 0) >= slab.target ? "Completed" : "Short";
        // const amount = (slab.target * slab.reward) / 100;
        const amount = parseInt(((total?.totalGrossAmt || 0) * slab.reward) / 100);
        const short = status === "Short" ? slab.target - (total?.totalGrossAmt || 0) : 0;

        return {
          commissionTarget: slab.target,
          tillNow: (total?.totalGrossAmt || 0),
          reward: slab.reward,
          amount,
          status,
          short,
          isRewardPercentage: slab.isRewardPercentage,
        };
      });

      return commissionDetails;
    } catch (error) {
      console.error("Error in getCommissionDetails:", error.message);
    }
  };

  const activitiesFromSearch = useMemo(() => {
    if (!searchResults) {
      return [];
    }
    const PrepairData = [];
    let totalGrossAmt = 0;
    let totalNetAmt = 0;
    let totalPayoutAmount = 0;
    let totalDueAmount = 0;
    let totalPaymentAmount = 0;
    let totalReceiptAmount = 0;
    searchResults.forEach((caseInfo) => {
      const CrossSellAmount = caseInfo.meta.crossSaleAmount || 0;
      // const newPddAmount=caseInfo.companyId.newPDDAmount || 0
      const ngstCalc = caseInfo.companyId.newGSTCalc;
      const ugstCalc = caseInfo.companyId.usedGSTCalc;
      const loanCategory = caseInfo.meta.loanType;
      const newPDDamount = caseInfo.companyId.newPDDAmount || 0;
      const usedPDDamount = caseInfo.companyId.usedPDDAmount || 0;
      const PddAmount = getPDDAmount(newPDDamount, usedPDDamount, loanCategory);
      const DueAmount = getPayout(caseInfo, "Due");
      if (!isNaN(DueAmount)) {
        totalDueAmount += DueAmount;
        setTotalDueAmount(totalDueAmount);
        // console.log("dp", totalDueAmount)
      }
      const payoutAmount = getPayout(caseInfo, "Payout");
      if (!isNaN(payoutAmount)) {
        totalPayoutAmount += payoutAmount;
        setTotalPayout(totalPayoutAmount);
      }
      const GSTEncExc = getGSTCalc(DueAmount, ngstCalc, ugstCalc, loanCategory);
      const agentName =
        caseInfo.agentId.personalInfo.firstName +
        " " +
        caseInfo.agentId.personalInfo.lastName +
        "-" +
        caseInfo.agentId.employmentType;
      const amount = caseInfo.meta.loanAmount - CrossSellAmount;
      const paymentAmount = getTotalAmount(caseInfo.paymentDetails);
      if (!isNaN(paymentAmount)) {
        totalPaymentAmount += paymentAmount;
        setNetPaid(totalPaymentAmount);
      }
      const receiptAmount = getTotalAmount(caseInfo.recieptDetails);
      if (!isNaN(receiptAmount)) {
        totalReceiptAmount += receiptAmount;
        setTotalReceived(totalReceiptAmount);
      }
      const difference = receiptAmount - paymentAmount;
      // const PDDamount = getTotalPDDAmount(caseInfo.PDDamount);
      const customerName = `${caseInfo.customerId.firstName} ${caseInfo.customerId.lastName}`;
      totalGrossAmt += caseInfo.meta.grossLoanAmount || 0;
      setGrossLoan(totalGrossAmt);
      totalNetAmt +=
        caseInfo.meta.loanAmount -
        caseInfo.meta.crossSaleAmount -
        caseInfo.meta.processingFees;
      if (!isNaN(totalNetAmt)) {
        setNetLoan(totalNetAmt);
      }
      const shortAmount = DueAmount - received;
      const loanType =
        caseInfo.meta.loanType + " " + (caseInfo.meta?.usedCarType || "");
      // const businessIRR = caseInfo.meta.businessIRR.toFixed(2);
      const currentDate = new Date();
      const otherDate = new Date(caseInfo.meta.loanDate);
      const timeDifference = Math.abs(
        currentDate.getTime() - otherDate.getTime()
      );
      const dayCount = Math.ceil(timeDifference / (1000 * 3600 * 24));
      const isPending =
        (!caseInfo.meta.RCRecv ||
          !caseInfo.meta.insuranceRec ||
          !caseInfo.meta.invoiceRecv ||
          !caseInfo.meta.parivahanStatus ||
          !caseInfo.meta.rtoSlip) &&
        new Date() - new Date(caseInfo.meta.loanDate) >=
          30 * 24 * 60 * 60 * 1000 &&
        new Date() - new Date(caseInfo.meta.loanDate) <=
          60 * 24 * 60 * 60 * 1000;
      const isCritical =
        (!caseInfo.meta.RCRecv ||
          !caseInfo.meta.insuranceRec ||
          !caseInfo.meta.invoiceRecv ||
          !caseInfo.meta.parivahanStatus ||
          !caseInfo.meta.rtoSlip) &&
        new Date() - new Date(caseInfo.meta.loanDate) >=
          61 * 24 * 60 * 60 * 1000;

      PrepairData.push({
        ...caseInfo,
        difference,
        payoutAmount,
        DueAmount,
        CrossSellAmount,
        GSTEncExc,
        agentName,
        amount,
        loanType,
        customerName,
        isPending,
        isCritical,
        dayCount,
        paymentAmount,
        receiptAmount,
        shortAmount,
        PddAmount,
      });
    });
    const commissionDetails = getCommissionDetails(totalGrossAmt);

    const results = {
      data: PrepairData,
      count,
      currentPageIndex,
      commissionDetails,
    };

    return results;
  }, [
    searchResults,
    currentProductCategory,
    currentActivityAssignedDateFrom,
    currentActivityAssignedDateTill,
    currentCompany,
    currentPageIndex,
    totalDueAmount,
    totalPayout,
  ]);

  // PAGE CHANGE
  const onPageChange = useCallback(
    (currentPage) => {
      setCurrentPageIndex(currentPage);
      dispatch(
        caseSearchAction({
          where,
          currentPage,
          fullTextSearch: true,
        })
      );
    },
    [
      dispatch,
      caseSearchAction,
      where,
      currentPageIndex,
      // currentPage,
      // where,
      // fullTextSearch,
    ]
  );

  const onSearchSubmit = useCallback(
    async (values, formikUtils) => {
      formikUtils.setSubmitting(false);
      const {
        productCategory,
        loanType,
        usedCarLoanType,
        CaseFromDate,
        CaseToDate,
        companyId,
        customerId,
        agentId,
        reportingManagerId,
        FilterCommissionId,
        employmentType,
        LoanPolicyNumber,
      } = values;

        // Check if CaseFromDate and CaseToDate are present
        if (!FilterCommissionId && (!CaseFromDate || !CaseToDate)) {
          dispatch(
            headerShowAction({
              data: "CaseFromDate and CaseToDate are required filters.",
            })
          );
          return;
        }
      // if (
      //   // THERE MUST BE AT LEAST ONE FILTER
      //   [
      //     productCategory,
      //     loanType,
      //     usedCarLoanType,
      //     CaseFromDate,
      //     CaseToDate,
      //     companyId,
      //     FilterCommissionId,
      //     agentId,
      //     reportingManagerId,
      //     employmentType,
      //     LoanPolicyNumber,
      //   ].filter((item) => !!item).length < 1
      // ) {
      //   dispatch(
      //     headerShowAction({
      //       data: "There must at least one filter to be added.",
      //     })
      //   );
      //   return;
      // }

      let where = {};

      // product Category
      if (productCategory) {
        set(where, "productCategory", productCategory);
        setProductCategory(productCategory);
      } else {
        setProductCategory(null);
      }

      if (loanType) {
        set(where, "meta.loanType", loanType);
      }
      if (usedCarLoanType) set(where, "meta.usedCarType", usedCarLoanType);

      // company
      if (companyId) {
        set(where, "companyId", companyId);
        setCurrentCompany(companyId);
      } else {
        setCurrentCompany(null);
      }

      // FROM
      if (CaseFromDate && !Number.isNaN(CaseFromDate.getTime())) {
        const fromDate = getStartOfDay(CaseFromDate);
        setCurrentActivityAssignedDateFrom(CaseFromDate);
        set(where, "meta.loanDate", { $gte: fromDate });
      } else {
        setCurrentActivityAssignedDateFrom(null);
      }

      // TILL
      if (CaseToDate && !Number.isNaN(CaseToDate.getTime())) {
        const tillDate = getEndOfDay(CaseToDate);
        const fromDate = getStartOfDay(CaseFromDate);
        setCurrentActivityAssignedDateTill(CaseToDate);

        set(where, "meta.loanDate", { $lte: tillDate });
        if (fromDate)
          set(where, "meta.loanDate", { $lte: tillDate, $gte: fromDate });
      } else {
        setCurrentActivityAssignedDateTill(null);
      }

      // CLIENT
      if (agentId) {
        where.agentId = agentId;
      }
      if (reportingManagerId) {
        where.reportingManagerId = reportingManagerId;
      }
        //CUSTOMER
        if (customerId) {
          where.customerId = customerId;
        }
      // CommissionId
      if (FilterCommissionId) {
        where = {};
        // set(where, 'invoiceDetails.commissionId', FilterCommissionId);
        const commissionId = { _id: FilterCommissionId };
        const localWhere = { ...commissionId }; // Create a local 'where' for commission search
        let {
          data: {
            data: { data: commissionMasterDT },
          },
        } = await commissionSearchAPI({
          where: {
            ...localWhere
          },
          autopopulate: false,
        });
        commissionMasterDT = commissionMasterDT[0];

        // Set commission master details
        setCommissionMaster(commissionMasterDT);

        // Calculate date range
        const fromDate = getStartOfDay(commissionMasterDT.FromDate);
        const tillDate = getEndOfDay(commissionMasterDT.ToDate);
        const loanType=commissionMasterDT.loanType;
        // Fetch company details
        let {
          data: {
            data: { data: company },
          },
        } = await companySearchAPI({
          where: { _id: commissionMasterDT.companyId },
          autopopulate: false,
        });
        company = company[0];
        // Set date range for current activity
        setCurrentActivityAssignedDateFrom(fromDate);
        setCurrentActivityAssignedDateTill(tillDate);

        // Update form values
        values.CaseFromDate = fromDate;
        values.CaseToDate = tillDate;
        values.companyId = company._id;
        values.loanType=loanType;
        // Set meta filter for loan date
        set(where, "meta.loanDate", { $gte: fromDate, $lte: tillDate });
        set(where, "companyId", company._id);
        set(where, "meta.loanType", loanType);

        // set(where,"companyId",companyId )
        // if (commissionMasterDT.loanType)
        //     set(where, 'loanType', commissionMasterDT.loanType);
        // if (commissionMasterDT.loanType == "USED" && commissionMasterDT.usedCarType)
        //     set(where, 'usedCarType', commissionMasterDT.usedCarType);
      } else {
        // setCurrentCompany(null);
      }

      if (employmentType) {
        const fetchUserIds = async (type, currentPage = 0) => {
          let allUserIds = [];
          let { data: { data: { data: userIdsChunk, pages } } } = await userSearchAPI({
            where: { employmentType: type },
            currentPage,
          });
        
          allUserIds = [...allUserIds, ...userIdsChunk.map(user => user._id)];
          const totalPages = pages;
          if (currentPage < totalPages) {
            const remainingUserIds = await fetchUserIds(type, currentPage + 1);
            allUserIds = [...allUserIds, ...remainingUserIds];
          }
        
          return allUserIds;
        };
        const getUserIds = async (employmentType) => {
          if (employmentType === "onroll&dsa") {
            const onRollUserIds = await fetchUserIds("ON_ROLL");
            const dsaUserIds = await fetchUserIds("DSA");
            return [...onRollUserIds, ...dsaUserIds];
          }
          return await fetchUserIds(employmentType);
        };
      
        const userIds = await getUserIds(employmentType);
     
        set(where, "agentId", { $in: userIds });
      }
      //LoanPolicyNumber
      if (LoanPolicyNumber) {
        if (productCategory === "VEHICLE_INSURANCE")
          set(where, "coverNotes.cn_number", LoanPolicyNumber);
        else set(where, "meta.LoanAccountNo", LoanPolicyNumber);
      }

      setWhere(where);
      pipeline(where);
      
      dispatch(
        excelCaseSearchAction({
          where,
          sortBy: "ts",
          sortOrder: -1,
          fullTextSearch: false,
        })
      );

      dispatch(
        caseSearchAction({
          where,
          currentPage: 0,
          sortBy: "ts",
          sortOrder: -1,
          fullTextSearch: false,
          pageLength: 50,
        })
      );
    },
    [dispatch]
  );

  const pipeline = async (where) => {
    // createMatchExpression(where)

// Stage 2: Calculate payoutAmount
const calculatePayoutStage = {
  $addFields: {
    payoutAmount: {
      $switch: {
        branches: [
          {
            case: {
              $eq: ["$companyDoc.payOut", "LoanAmtCrossSale"]
            },
            then: {
              $round: {
                $multiply: [
                  {
                    $sum: [
                      "$meta.loanAmount",
                      {
                        $multiply: [
                          -1,
                          {
                            $multiply: [
                              "$meta.EMIAmount",
                              "$meta.EMIAdvance"
                            ]
                          }
                        ]
                      },
                      "$meta.crossSaleAmount"
                    ]
                  },
                  {
                    $divide: [
                      "$agentCommissionPercentage",
                      100
                    ]
                  }
                ]                 
              }
            }
          },
          {
            case: {
              $eq: ["$companyDoc.payOut", "LoanAmtLessPF"]
            },
            then: {
              $round:{
                  
                $multiply: [
                  {
                    $sum: [
                      "$meta.loanAmount",
                      {
                        $multiply: [
                          -1,
                          {
                            $sum: [
                              {
                                $multiply: [
                                  "$meta.EMIAmount",
                                  "$meta.EMIAdvance"
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        $multiply: [
                          -1,
                          "$meta.processingFees"
                        ]
                      }
                    ]
                  },
                  {
                    $divide: [
                      "$agentCommissionPercentage",
                      100
                    ]
                  }
                ]
                    }
                
            }
          },
          {
            case: {
              $eq: ["$companyDoc.payOut", "LoanAmt"]
            },
            then: {
              $round: {
               
                $multiply: [
                  {
                    $sum: [
                      "$meta.loanAmount",
                      {
                        $multiply: [
                          -1,
                          {
                            $multiply: [
                              "$meta.EMIAmount",
                              "$meta.EMIAdvance"
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    $divide: [
                      "$agentCommissionPercentage",
                      100
                    ]
                  }
                ]
                  }
              
            }
          },
          {
            case: {},
            then: { 
              $round: {
                $multiply: [
                  {
                    $subtract: [
                      {
                        $sum: [
                          "$meta.loanAmount",
                          "$meta.crossSaleAmount"
                        ]
                      },
                      {
                        $sum: [
                          {
                            $multiply: [
                              "$meta.EMIAmount",
                              "$meta.EMIAdvance"
                            ]
                          },
                          "$meta.processingFees"
                        ]
                      }
                    ]
                  },
                  {
                    $divide: [
                      "$agentCommissionPercentage",
                      100
                    ]
                  }
                ]
              }
            }
          }
        ],
        default: 0
      }
    }
  }
};
// Stage 3: Calculate existing amount for payoutAmount
const calculateExistingAmountForPayout={
  $addFields:{
    existingAmountForPayout: {
      $cond: [
        { $eq: [{ $size: { $ifNull: ["$paymentDetails", []] } }, 0] },
        0,
        {
          $reduce: {
            input: {
              $filter: {
                input: "$paymentDetails",
                cond: { $not: "$$this.deleted" } // Filter out payments where deleted is true
              }
            },
            initialValue: 0,
            in: { $sum: ["$$value", "$$this.amount"] }
          }
        }
      ]
    }
  }
 
}
// Stage 4: Calculate grand total payoutAmount
const calculatePayoutAmountStage = {
  $addFields: {
    finalPayoutAmount: { $subtract: ["$payoutAmount", "$existingAmountForPayout"] }
  }
};
// Stage 5: Calculate dueAmount
const calculateDueAmount = {
  $addFields: {
    dueAmount: {
      $switch: {
        branches: [
          {
            case: {
              $eq: ["$companyDoc.payOut", "LoanAmtCrossSale"]
            },
            then: {
              $round: {
                $multiply: [
                  {
                    $sum: [
                      "$meta.loanAmount",
                      {
                        $multiply: [
                          -1,
                          {
                            $multiply: [
                              "$meta.EMIAmount",
                              "$meta.EMIAdvance"
                            ]
                          }
                        ]
                      },
                      "$meta.crossSaleAmount"
                    ]
                  },
                  {
                    $divide: [
                      "$companyCommissionPercentage",
                      100
                    ]
                  }
                ]             
              }
            }
          },
          {
            case: {
              $eq: ["$companyDoc.payOut", "LoanAmtLessPF"]
            },
            then: {
              $round:{
                  
                $multiply: [
                  {
                    $sum: [
                      "$meta.loanAmount",
                      {
                        $multiply: [
                          -1,
                          {
                            $sum: [
                              {
                                $multiply: [
                                  "$meta.EMIAmount",
                                  "$meta.EMIAdvance"
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        $multiply: [
                          -1,
                          "$meta.processingFees"
                        ]
                      }
                    ]
                  },
                  {
                    $divide: [
                      "$companyCommissionPercentage",
                      100
                    ]
                  }
                ]
                    }
                
            }
          },
          {
            case: {
              $eq: ["$companyDoc.payOut", "LoanAmt"]
            },
            then: {
              $round: {
                $multiply: [
                  {
                    $sum: [
                      "$meta.loanAmount",
                      {
                        $multiply: [
                          -1,
                          {
                            $multiply: [
                              "$meta.EMIAmount",
                              "$meta.EMIAdvance"
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    $divide: [
                      "$companyCommissionPercentage",
                      100
                    ]
                  }
                ]
                  }
              
            }
          },
          {
            case: {},
            then: { 
              $round: {
                $multiply: [
                  {
                    $subtract: [
                      {
                        $sum: [
                          "$meta.loanAmount",
                          "$meta.crossSaleAmount"
                        ]
                      },
                      {
                        $sum: [
                          {
                            $multiply: [
                              "$meta.EMIAmount",
                              "$meta.EMIAdvance"
                            ]
                          },
                          "$meta.processingFees"
                        ]
                      }
                    ]
                  },
                  {
                    $divide: [
                      "$companyCommissionPercentage",
                      100
                    ]
                  }
                ]
              }
            }
          }
        ],
        default: 0
      }
    }
  }
};
// Stage 6: Calculate existing amount for due
const calculateExistingAmountForDue={
  $addFields:{
    existingAmountForDue: {
      $cond: [
        { $eq: [{ $size: { $ifNull: ["$recieptDetails", []] } }, 0] },
        0,
        {
          $reduce: {
            input: {
              $filter: {
                input: "$recieptDetails",
                cond: { $not: "$$this.deleted" } // Filter out payments where deleted is true
              }
            },
            initialValue: 0,
            in: { $sum: ["$$value", "$$this.amount"] }
          }
        }

      ]
    }
  }
 
}
// Stage 7: Calculate grand total dueAmount
const calculateDueAmountStage = {
  $addFields: {
    finalDueAmount: { $subtract: ["$dueAmount", "$existingAmountForDue"] }
  }
};
// Stage 8: Group and calculate totals
const groupStage = {
  $group: {
    _id: null,
    totalGrossAmt: {
      $sum: {
        $ifNull: ['$meta.grossLoanAmount', 0]
      }
    },
    totalNetAmt: {
      $sum: {
        $subtract: [
          '$meta.loanAmount',
          {
            $add: ['$meta.crossSaleAmount', '$meta.processingFees']
          }
        ]
      }
    },
    totalPayoutAmount: {
      $sum: "$finalPayoutAmount"
    },
    totalExistingAmountForPayout:{
      $sum: '$existingAmountForPayout'
    },
    totalDueAmount: {
      $sum: "$finalDueAmount"
    },
    totalExistingAmountForDue:{
      $sum: '$existingAmountForDue'
    },
    count: { $sum: 1 }, 
  }
};
// Stage 9: Project required fields
const projectStage = {
  $project: {
    _id: 0,
    totalGrossAmt: 1,
    totalNetAmt: 1,
    totalPayoutAmount: 1,
    totalExistingAmountForPayout:1,
    totalDueAmount: 1,
    totalExistingAmountForDue:1,
    companyDoc: 1,
    count:1
  }
};
// Combine all stages into the pipeline array
const pipelineStages = [
  calculatePayoutStage,
  calculateExistingAmountForPayout,
  calculatePayoutAmountStage,
  calculateDueAmount,
  calculateExistingAmountForDue,
  calculateDueAmountStage,
  groupStage,
  projectStage
];

const pipelineHelper={
  where,
  pipelineStages
}
    let {
      data: {
        data: [totalPipe]
      }
    } = await pipelineApi(pipelineHelper);
    setTotal(totalPipe)
  }
  // const onCommissionSubmit = useCallback(async (
  //     values,
  //     formikUtils,
  // ) => {
  //     formikUtils.setSubmitting(false);
  //     const {
  //         FilterCommissionId,
  //     } = values;

  //     let where = {
  //     };

  //     // FROM
  //     if (CaseFromDate && !Number.isNaN(CaseFromDate.getTime())) {
  //         const fromDate = getStartOfDay(CaseFromDate);
  //         setCurrentActivityAssignedDateFrom(CaseFromDate);
  //         set(where, 'ts', { $gte: fromDate });
  //     }
  //     else {
  //         setCurrentActivityAssignedDateFrom(null);
  //     }

  //     // TILL
  //     if (CaseToDate && !Number.isNaN(CaseToDate.getTime())) {
  //         const tillDate = getEndOfDay(CaseToDate);
  //         setCurrentActivityAssignedDateTill(CaseToDate);
  //         set(where, 'ts', { $lte: tillDate });
  //     }
  //     else {
  //         setCurrentActivityAssignedDateTill(null);
  //     }
  //     //FilterCommissionId
  //     if(FilterCommissionId)
  //     {
  //         set(where, 'ts', { $lte: tillDate });
  //     }
  //     setWhere(where);
  //     dispatch(caseSearchAction({
  //         where,
  //         currentPage: 0,
  //         sortBy: 'ts',
  //         sortOrder: -1,
  //         fullTextSearch: false,
  //         pageLength: 10,
  //     }));
  // }, [
  //     dispatch,
  // ]);

  const onClear = useCallback(() => {
    dispatch(caseResetAction());
    setFilterInitialValues({
      ...filterDefaultValues,
    });
  }, [dispatch]);

  const generateInvoice = useCallback(
    async (commissionId) => {
      const payload = {
        commissionId: commissionId,
        data: invoiceInitialValues,
      };
      const invoice = await caseInvoiceCreateAPI(payload);
      closeAlertDialog("invoice");
      dispatch(
        headerShowAction({
          data: "Invoice has been created successfully.",
        })
      );
    },
    [invoiceInitialValues]
  );

  const handleReceipt = useCallback();
  //   async (_id) => {
  //     const payload = {
  //       caseId:_id,
  //       value:[{
  //         mode:mode,
  //         date:date,
  //         amount:AmountToReceive,
  //         instrument_number:'',
  //         remarks:''
  //       }]

  //     };
  //     const receipt = await caseReceiptCreateAPI(payload);
  //     closeAlertDialog("dueAmount");
  //     dispatch(
  //       headerShowAction({
  //         data: "Receipt updated successfully.",
  //       })
  //     );
  //   },
  //   []
  const handlePayment = useCallback();
  //   async (_id) => {
  //     const payload = {
  //       commissionId: commissionId,
  //       data: invoiceInitialValues,
  //     };
  //     const invoice = await casePaymentCreateAPI(payload);
  //     closeAlertDialog("Payout");
  //     dispatch(
  //       headerShowAction({
  //         data: " Payment updated successfully.",
  //       })
  //     );
  //   },
  //   [invoiceInitialValues]
  const handleChange = useCallback(
    (e) => {
      const id = e.target.name;
      const checked = e.target.value;
      // const pay = e.target.payment;
      const payOut = e.target.getAttribute("data-Payout");
      const due = e.target.getAttribute("data-due");
      const paid = e.target.getAttribute("data-paid");
      const received = e.target.getAttribute("data-received");
      if (checked === "false") {
        setInvoiceInitialValues([...invoiceInitialValues, id]);
        setPendingPayOutList([
          ...pendingPayOutList,
          { id, amount: parseInt(payOut) },
        ]);
        setPendingDueList([...pendingDueList, { id, amount: parseInt(due) }]);
        setReceived((prevTotal) => prevTotal + parseInt(received));
        setPaid((prevTotal) => prevTotal + parseInt(paid));
        setTotalCheckedPayOut((prevTotal) => prevTotal + parseInt(payOut));
        setTotalCheckedDue((prevTotal) => prevTotal + parseInt(due));
      } else {
        setInvoiceInitialValues(
          invoiceInitialValues.filter((item) => {
            return id !== item;
          })
        );
        setPendingPayOutList(
          pendingPayOutList.filter((item) => {
            return id !== item.id;
          })
        );
        setPendingDueList(
          pendingDueList.filter((item) => {
            return id !== item.id;
          })
        );
        setReceived((prevTotal) => prevTotal - parseInt(received));
        setPaid((prevTotal) => prevTotal - parseInt(paid));
        setTotalCheckedPayOut((prevTotal) => prevTotal - parseFloat(payOut));
        setTotalCheckedDue((prevTotal) => prevTotal - parseInt(due));
      }
      // console.log('recet',receiptValues,invoiceInitialValues)
      // setInvoiceInitialValues(id)

      // data.push(id);
      //   console.log("checked", checked);
      //   console.log("invoiceInitialValues=>", invoiceInitialValues);
      // if()
      // else
      // console.log('invoiceInitialValues=>', invoiceInitialValues, data);

      return data;
    },
    [
      // dispatch,
      invoiceInitialValues,
      receiptValues,
    ]
  );
  useEffect(() => {
    handlDueAmount();
    // matchAndPushAmount()
  }, [receiptValues]);
  // useEffect(()=>{
  //   // handlDueAmount()
  //   matchAndPushAmount()
  // },[])

  const handlDueAmount = () => {
    if (receiptValues.length > 0) {
      console.log("recet", receiptValues, totalCheckedPayOut, totalCheckedDue);
    }
  };

  // const matchAndPushAmount = () => {
  //   const updatedReceiptValues = receiptValues.map((receipt) => {
  //     const matchingPayment = recPayDue.find((payment) => payment.id === receipt.id);
  //     console.log('match',matchingPayment)
  //     if (matchingPayment) {
  //       return { ...receipt, DueAmount: matchingPayment.DueAmount };
  //     }
  //     return receipt;
  //   });

  //   const total = updatedReceiptValues.reduce((sum, receipt) => sum + receipt.DueAmount, 0);

  //   setReceiptValues(updatedReceiptValues);
  //   setTotalAmount(total);
  // };

  const ExportInExcel = useMemo(() => {
    if (!excelSearchResults) {
      return [];
    }
    const results = [];
    let totalGrossAmt = 0;
    excelSearchResults.forEach((caseInfo) => {
      const CrossSellAmount = caseInfo.meta.crossSaleAmount || 0;
      const ngstCalc = caseInfo.companyId.newGSTCalc;
      const ugstCalc = caseInfo.companyId.usedGSTCalc;
      const newPDDamount = caseInfo.companyId.newPDDAmount || 0;
      const usedPDDamount = caseInfo.companyId.usedPDDAmount || 0;
      const loanCategory = caseInfo.meta.loanType;
      const companyName = caseInfo.companyId.companyName;
      const PddAmount = getPDDAmount(newPDDamount, usedPDDamount, loanCategory);
      const DueAmount = getPayout(caseInfo, "Due");
      const payoutAmount = getPayout(caseInfo, "Payout");
      const GSTEncExc = getGSTCalc(DueAmount, ngstCalc, ugstCalc, loanCategory,companyName);
      const agentName =
        caseInfo.agentId.personalInfo.firstName +
        " " +
        caseInfo.agentId.personalInfo.lastName +
        "-" +
        caseInfo.agentId.employmentType;
      const amount = caseInfo.meta.loanAmount - CrossSellAmount;
      const paymentAmount = getTotalAmount(caseInfo.paymentDetails);
      const receiptAmount = getTotalAmount(caseInfo.recieptDetails);
      const difference = receiptAmount - paymentAmount;
      // const PDDamount = getTotalPDDAmount(caseInfo.PDDamount);
      const customerName = `${caseInfo.customerId.firstName} ${caseInfo.customerId.lastName}`;
      totalGrossAmt += caseInfo.meta.grossLoanAmount || 0;
      // setGrossLoan(totalGrossAmt);
      const loanType =
        caseInfo.meta.loanType + " " + (caseInfo.meta?.usedCarType || "");
      const loanDate = new Date(caseInfo.meta.loanDate);
      const firsttEMI = new Date(caseInfo.meta.firstEMI);
      const lastEMI = new Date(caseInfo.meta.LastEMIDate);
      const disbursmentDate = new Date(caseInfo.meta.loanDate);
      const dateOptions = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      };
      const formattedLoanDate = loanDate.toLocaleDateString(
        "en-GB",
        dateOptions
      );
      const formattedFirstEMIDate = firsttEMI.toLocaleDateString(
        "en-GB",
        dateOptions
      );
      const formattedLastEMIDate = lastEMI.toLocaleDateString(
        "en-GB",
        dateOptions
      );
      const formattedDisbusmentDate = disbursmentDate.toLocaleDateString(
        "en-GB",
        dateOptions
      );
      const formattedDate = new Date(caseInfo.ts).toLocaleDateString(
        "en-GB",
        dateOptions
      );
      // const businessIRR = caseInfo.meta.businessIRR.toFixed(2);
      results.push({
        "Loan Date": formattedLoanDate,
        "Loan Type": loanType,
        // "Car Loan Type": caseInfo.meta.usedCarType,
        "Loan A/c/Policy Number": caseInfo.meta.LoanAccountNo,
        "Name of Customer": customerName,
        "Model Name": caseInfo.meta.vehicleProductId.productName,
        "Loan Amount": caseInfo.meta.loanAmount,
        "Cross Sell Amount": CrossSellAmount,
        "Advance EMI": caseInfo.meta.EMIAdvance,
        "EMI Amount": caseInfo.meta.EMIAmount,
        "Gross Loan Amount": caseInfo.meta.grossLoanAmount,
        Tenure: caseInfo.meta.tenure,
        ROI: caseInfo.meta.businessIRR,
        "Processing Fees": caseInfo.meta.processingFees,
        "Disbursed Amount": caseInfo.meta.disbursedAmount,
        "Dealer/Showroom": caseInfo.meta?.showroomDealer?.companyDisplayName,
        "Bank/Company Name": caseInfo.companyId.companyName,
        "Assigned Agent Name":
          caseInfo.agentId.personalInfo.firstName +
          " " +
          caseInfo.agentId.personalInfo.lastName,
        "Employment Type":caseInfo?.agentId?.employmentType || '',
        "Reporting Manager Name":
          caseInfo.reportingManagerId.personalInfo.firstName +
          " " +
          caseInfo.reportingManagerId.personalInfo.lastName,
        "Bank Payment Rate": caseInfo.companyCommissionPercentage,
        "Due Amount": DueAmount,
        "Received Amount": receiptAmount,
        "PDD Amount": PddAmount,
        "Agent Payout Rate(%)": caseInfo.agentCommissionPercentage,
        "Payout Amount": payoutAmount,
        "Paid Amount": caseInfo.paymentAmount,
        "Disbursement Date": formattedDisbusmentDate,
        "GST(Inc/Exc)": GSTEncExc,
         Saving: difference,
        "Created By": caseInfo.by.personalInfo.firstName,
        Date: formattedDate,
      });
    });

    return results;
  }, [
    excelSearchResults,
    currentProductCategory,
    currentActivityAssignedDateFrom,
    currentActivityAssignedDateTill,
    currentCompany,
  ]);
  const viewRemarks = async (id) => {
    openAlertDialog("remarks");
    if (!id) return;

    let where = {
      refId: id,
      deleted: false,
      source: "cases",
    };

    const {
      data: {
        data: { data: remarks },
      },
    } = await remarkSearchAPI({
      where,
      sortBy: "ts",
      pageLength: 0,
      currentPage: 1,
      autopopulate: false,
    });
    setRemarksDetails(remarks);
  };

  // EDIT
  const editClick = useCallback(
    (record) => {
      dispatch(caseEditAction(record));
      history.push(RoutingUtil.caseManagerUrl());
    },
    [dispatch, caseEditAction, history]
  );
  return (
    <div>
      <Formik
        onSubmit={onSearchSubmit}
        onClear={onClear}
        enableReinitialize
        initialValues={filterInitialValues}
        // validationSchema={}
      >
        {(formikProps) => (
          <RenderFilters
            // forceRefreshSearchContainer={forceRefreshSearchContainer}
            onClear={onClear}
            {...formikProps}
            invoiceInitialValues={invoiceInitialValues}
            activityList={activitiesFromSearch}
            userType={userType}
            ExportInExcel={ExportInExcel}
            handleChange={handleChange}
            generateInvoice={generateInvoice}
            handleReceipt={handleReceipt}
            handlePayment={handlePayment}
            history={history}
            onPageChange={onPageChange}
            alertModalClass={alertModalClass}
            alertDisplay={alertDisplay}
            openAlertDialog={openAlertDialog}
            closeAlertDialog={closeAlertDialog}
            dueAmountModalClass={dueAmountModalClass}
            dueAmountDisplay={dueAmountDisplay}
            payoutModalClass={payoutModalClass}
            payoutDisplay={payoutDisplay}
            viewRemarks={viewRemarks}
            editClick={editClick}
            totalPayout={totalPayout}
            totalDueAmount={totalDueAmount}
            paid={paid}
            netPaid={netPaid}
            received={received}
            netReceived={netReceived}
            grossLoan={grossLoan}
            netLoan={netLoan}
            totalCheckedDue={totalCheckedDue}
            totalCheckedPayOut={totalCheckedPayOut}
            pendingDueList={pendingDueList}
            pendingPayOutList={pendingPayOutList}
            total={total}
          />
        )}
      </Formik>

      {/* <div className={`modal fade ${(invoiceModal) ? 'show' : ''}`} id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"> */}
      <div
        className={`modal fade ${remarksModalClass}`}
        id="authAlert"
        style={{
          display: `${remarksDisplay}`,
          overflowY: "scroll",
          opacity: "1",
          background: "rgba(0, 0, 0, 0.5)",
        }}
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                View Remarks
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => closeAlertDialog("remarks")}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group col-md-12">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">Sr. No.</th>
                      <th scope="col">Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {remarksDetails.map((remark, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{remark.text}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => closeAlertDialog("remarks")}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccntPayoutCal;
